define.alias("shared/components/shared/ui/calculating-state", "calendar/components/shared/ui/calculating-state");